import { ID_SPLITTER } from "../dataTypes";

const buildId = (...objects: any[]) => objects.join(ID_SPLITTER);

export default buildId;
